import React from 'react';
import { Clock, Mail, MapPin, Phone } from 'lucide-react';
import { BusinessHours } from './BusinessHours';
import { TireServicesBanner } from './TireServicesBanner';
import { EMAIL } from '../data/site';

export const LocationDetails = ({ location }) => (
  <section className="location-details" data-testid={`contact-location-${location.id}`}>
    <h3>{location.name} Location</h3>
    {location.id === 'desert-meadows' && <><p className="location-subtitle" data-testid="contact-desert-meadows-summary">{location.address}, {location.city}</p><TireServicesBanner testId="contact-tire-services" /></>}
    <div className="contact-info-grid">
      <div className="contact-detail"><Phone aria-hidden="true" /><h4>Phone</h4><a href={location.tel} data-testid={`contact-phone-${location.id}`}>{location.phone}</a></div>
      <div className="contact-detail"><Mail aria-hidden="true" /><h4>Email</h4><a href={`mailto:${EMAIL}`} className="email-link" data-testid={`contact-email-${location.id}`}>{EMAIL}</a></div>
      <div className="contact-detail"><MapPin aria-hidden="true" /><h4>Address</h4><p data-testid={`contact-address-${location.id}`}>{location.address}<br />{location.city}</p></div>
      <div className="contact-detail"><Clock aria-hidden="true" /><h4>Hours</h4><BusinessHours testId={`contact-hours-${location.id}`} /></div>
    </div>
  </section>
);